interface PointsProgress {
	currentPoints: number;
	nextTier: number;
	pointsUntilNext: number;
	percentage: number;
}

export function calculatePointsProgress(currentPoints: number): PointsProgress {
	// Calculate next tier as the next whole thousand
	const nextTier = Math.ceil(currentPoints / 1000) * 1000;

	// If already at a thousand milestone, go to next thousand
	const finalNextTier = currentPoints % 1000 === 0 ? currentPoints + 1000 : nextTier;

	const pointsUntilNext = finalNextTier - currentPoints;

	// Calculate percentage complete in current tier
	const currentTierStart = Math.floor(currentPoints / 1000) * 1000;
	const tierProgress = currentPoints - currentTierStart;
	const percentageComplete = Math.round((tierProgress / 1000) * 100);

	return {
		currentPoints,
		nextTier: finalNextTier,
		pointsUntilNext,
		percentage: percentageComplete,
	};
}
